module.exports = __webpack_public_path__ + "static/media/search.67a1fafd.svg";